import Logger from '../lib/logger';
import event from '../lib/mixins/event';

class ThemeHeader {

	constructor(dom) {
		this.NAME = 'ThemeHeader';
		this.dom = dom;
		this.activeClass = 'theme-header--active';
		this.burgerDoms = this.dom.querySelectorAll('[data-theme-header-burger]');
		this.overlayDom = document.querySelector('[data-theme-header-overlay]');
		this.closeDoms = document.querySelectorAll('[data-theme-header-close]');
	}

	init() {
		Logger.info(`${this.NAME} > init`);

		this.burgerDoms.forEach(burger => {
			burger.addEventListener('click', this.toggle.bind(this));
		});

		if (this.overlayDom) {
			this.overlayDom.addEventListener('click', this.close.bind(this));
		}

		this.closeDoms.forEach(close => {
			close.addEventListener('click', this.close.bind(this));
		});
	}

	open() {
		this.dom.classList.add(this.activeClass);
		document.body.classList.add('no-scroll');
	}

	close() {
		this.dom.classList.remove(this.activeClass);
		document.body.classList.remove('no-scroll');
	}

	toggle() {
		if (this.dom.classList.contains(this.activeClass)) {
			this.close();
		} else {
			this.open();
		}
	}

	revealIntro() {
		this.dom.classList.add('theme-header--intro-done');
	}

}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
